<script module>
  import { gql } from '$lib/graphql.svelte.js'

  export const i18n = {
    en: {
      NON_FLEX: 'Non-refundable',
      SEMI_FLEX: 'Partly refundable',
      FULL_FLEX: 'Fully refundable',
      AdmissionPart: 'Ticket',
      ReservationPart: 'Seat reservation',
      SEAT: 'Seat',
      BERTH: 'Sleeper',
      COUCHETTE: 'Couchette',
      GENDER: 'Select cabin category',
      'Select GENDER': 'Select category',
      MEN: "Men's cabin",
      LADIES: "Women's cabin",
      MIXED: 'Mixed cabin',
      PLACE_OR_COMPARTMENT_LOCATION: 'Preferred place',
      'Select PLACE_OR_COMPARTMENT_LOCATION': 'Select preferred place',
      AISLE: 'Aisle',
      WINDOW: 'Window',
      DDL: 'Double Decker Lower Floor',
      DDU: 'Double Decker Upper Floor',
      SPECIAL_COMPARTMENT_TYPE: 'Special preference',
      'Select SPECIAL_COMPARTMENT_TYPE': 'Select special preference',
      EASY_ACCESS: 'Easily accessible seat',
      TABLE: 'Seat with table',
      SOLO: 'Separate seat',
      WITHOUT_ANIMALS: 'No animals',
      ADULT: 'Adult',
      YOUTH: 'Youth',
      SENIOR: 'Senior',
      '%s years': {
        one: '%s year',
        other: '%s years'
      }
    },
    sv: {
      'Journey details': 'Resedetaljer',
      NON_FLEX: 'Kan ej ombokas',
      SEMI_FLEX: 'Kan delvis återbetalas',
      FULL_FLEX: 'Kan återbetalas',
      AdmissionPart: 'Biljett',
      ReservationPart: 'Reservation',
      SEAT: 'Sittplats',
      BERTH: 'Sängplats',
      COUCHETTE: 'Liggkupé',
      GENDER: 'Välj typ av kupé',
      'Select GENDER': 'Välj kategori',
      MEN: 'Herrar',
      LADIES: 'Damer',
      MIXED: 'Blandat',
      PLACE_OR_COMPARTMENT_LOCATION: 'Önskad plats',
      'Select PLACE_OR_COMPARTMENT_LOCATION': 'Välj önskad plats',
      AISLE: 'Gång',
      WINDOW: 'Fönster',
      DDL: 'Dubbeldäck, nedre plan',
      DDU: 'Dubbeldäck, övre plan',
      SPECIAL_COMPARTMENT_TYPE: 'Platsegenskap',
      'Select SPECIAL_COMPARTMENT_TYPE': 'Välj platsegenskap',
      EASY_ACCESS: 'Lättåtkomlig plats',
      TABLE: 'Plats med bord',
      SOLO: 'Separerad plats',
      WITHOUT_ANIMALS: 'Djurfritt',
      Comfort: 'Komfort',
      'Select class': 'Välj klass',
      'Select comfort': 'Välj komfort',
      'Select flexibility': 'Välj flexibilitet',
      'Mixed comfort class': 'Blandad komfortklass',
      Conditions: 'Villkor',
      '1st Class': '1 klass',
      '2nd Class': '2 klass',
      '1st class': '1 klass',
      '2nd class': '2 klass',
      '2nd class Calm': '2 klass lugn',
      'First Class': '1 klass',
      'Standard Class': '2 klass',
      'Private couchette`': 'Privat liggkupé',
      'Mini cabin': 'Minihytt',
      'Single sleeper': 'Enkel sovkupé',
      'Double sleeper': 'Dubbel sovkupé',
      'Triple sleeper': 'Trippel sovkupé',
      'Private sleeper': 'Privat sovkupé',
      '4 person couchette cabin': '4 bäddar i liggkupé',
      '4 person couchette cabin (womens)': '4 bäddar i liggkupé (kvinnor)',
      '5 person couchette cabin': '5 bäddar i liggkupé',
      '6 person couchette cabin': '6 bäddar i liggkupé',
      'Private 4 person couchette cabin': 'Privat 4 bäddar i liggkupé',
      'Private 5 person couchette cabin': 'Privat 5 bäddar i liggkupé',
      'Private 6 person couchette cabin': 'Privat 6 bäddar i liggkupé',
      '1 person mini cabin (capsule)': '1 person i minihytt',
      '1 person sleeper cabin': '1 person i sovkupé',
      '2 person sleeper cabin': '2 bäddar i sovkupé',
      '3 person sleeper cabin': '3 bäddar i sovkupé',
      'Private 3 person sleeper cabin': 'Privat 3 bäddar i sovkupé',
      'Private 2 person sleeper cabin': 'Privat 2 bäddar i sovkupé',
      'Silent area': 'Tyst avdelning',
      'Private area': 'Privat avdelning',
      'Family area': 'Familjeavdelning',
      'Executive area': 'Första klass Executive',
      'Premium comfort area': 'Premium komfort',
      ADULT: 'Vuxen',
      YOUTH: 'Ungdom',
      SENIOR: 'Senior',
      '%s years': {
        one: '%s år',
        other: '%s år'
      },
      'Add-ons': 'Tillval',
      'Select add-ons': 'Välj tillval',
      'No selected add-ons': 'Inga tillval valda',
      'Show add-ons': 'Visa tillval',
      'Hide add-ons': 'Dölj tillval'
    }
  }

  const ReturnConditionFragment = gql`
    fragment ReturnConditionFragment on ReturnCondition {
      description
      type
    }
  `

  const LocationFragment = gql`
    fragment LocationFragment on Location {
      uid
      countryCode
    }
  `

  const MoneyFragment = gql`
    fragment MoneyFragment on Money {
      amount
      currency
    }
  `

  export const OfferFragment = gql`
    fragment OfferFragment on Offer {
      id
      price {
        ...${MoneyFragment}
      }
      parts {
        __typename
        price {
          ...${MoneyFragment}
        }
        segments {
          identifier
          operator {
            name
          }
          origin {
            name
          }
          destination {
            name
          }
        }
        ... on AdmissionPart {
          conditions {
            ...${ReturnConditionFragment}
          }
          flexibility
          serviceClass
          comfortClass
        }
        ... on ReservationPart {
          id
          conditions {
            ...${ReturnConditionFragment}
          }
          flexibility
          comfortClass
          accommodation {
            type
            subType
            description
          }
          placeProperties {
            id
            type
            required
            availableOptions {
              id
              value
            }
            selectedOption {
              id
              value
            }
          }
          ancillaries {
            description
            id
            name
            type
            price {
              amount
              currency
            }
            selections {
              id
              passengerId
            }
          }
        }
      }
    }
  `

  export const OfferFragmentSegments = gql`
    fragment OfferFragmentSegments on Segment {
      departureAt
      arrivalAt
      duration
      identifier
      direction
      transport
      serviceBrand {
        name
        image {
          url
        }
      }
      operator {
        name
        image {
          url
        }
      }
      origin {
        name
        ... on Location {
          ...${LocationFragment}
        }
      }
      destination {
        name
        ... on Location {
          ...${LocationFragment}
        }
      }
    }
  `

  /**
   * @param {Schema.Offer} offer
   * @param {Schema.Segment[]} segments
   */
  export function populateSegments(offer, segments) {
    const parts = offer.parts.map((part) => {
      return {
        ...part,
        segments: part.segments.map(({ id }) => {
          const segment = segments.find((segment) => segment.id === id)
          if (!segment) throw new Error('Could not populate segment')
          return segment
        })
      }
    })
    return { ...offer, parts }
  }
</script>

<script>
  import { differenceInCalendarDays } from 'date-fns'

  import { register } from '$lib/utils/text.svelte.js'
  import { money } from '$lib/utils/money.svelte.js'
  import { getConfig } from '$lib/Config.svelte'
  import State from '$lib/utils/state.svelte.js'
  import Accordion from '$lib/Accordion.svelte'
  import Symbol from '$lib/Symbol.svelte'
  import Loader from '$lib/Loader.svelte'
  import Select from '$lib/Select.svelte'
  import Html from '$lib/Html.svelte'

  /** @type {Schema.ServiceClass[]} */
  const SERVICE_CLASSES = ['BASIC', 'STANDARD', 'HIGH', 'BEST']
  const FIRST_CLASS_SERVICE_CLASSES = SERVICE_CLASSES.slice(-2)
  const SECOND_CLASS_SERVICE_CLASSES = SERVICE_CLASSES.slice(0, 2)

  /** @type {Schema.Flexibility[]} */
  const FLEXIBILITY_TYPES = ['UNKNOWN', 'NON_FLEX', 'SEMI_FLEX', 'FULL_FLEX']

  const config = getConfig()

  /**
   * @template T
   * @param {T[]} array
   * @returns {T[]}
   */
  const unique = (array) => Array.from(new Set(array))

  /** @param {Schema.Offer} offer */
  const isFirstClass = (offer) =>
    offer.parts.some(
      (part) =>
        'serviceClass' in part &&
        FIRST_CLASS_SERVICE_CLASSES.includes(part.serviceClass)
    )

  /** @param {Schema.Offer} offer */
  const isSecondClass = (offer) =>
    offer.parts.some(
      (part) =>
        'serviceClass' in part &&
        SECOND_CLASS_SERVICE_CLASSES.includes(part.serviceClass)
    )

  /** @param {Schema.Offer} offer */
  const highestFlexibility = (offer) => {
    const flexibilities = unique(
      offer.parts.filter((part) => part.price).map((part) => part.flexibility)
    )
    return flexibilities.length === 1 ? flexibilities[0] : 'SEMI_FLEX'
  }

  /** @param {Schema.Offer[]} [offers] */
  const cheapestOfferPerFlexibility = (offers) => {
    if (!offers) return []

    const flexibilities = offers.reduce((acc, offer) => {
      // Get the highest flexibility from the offer
      const flexibility = highestFlexibility(offer)

      const diff =
        FLEXIBILITY_TYPES.indexOf(flexibility) -
        FLEXIBILITY_TYPES.indexOf(
          acc[flexibility] ? highestFlexibility(acc[flexibility]) : 'UNKNOWN'
        )

      // Prefer least flexible and cheapest offer
      if (
        !acc[flexibility] ||
        diff < 0 ||
        (diff === 0 && offer.price.amount < acc[flexibility].price.amount)
      ) {
        acc[flexibility] = offer
      }

      return acc
    }, /** @type {Record<Schema.Flexibility, Schema.Offer?>} */ ({}))

    if (Object.keys(flexibilities).length < 2) {
      if (!flexibilities.FULL_FLEX) {
        flexibilities['FULL_FLEX'] = null
      } else if (!flexibilities.NON_FLEX) {
        flexibilities['NON_FLEX'] = null
      }
    }

    return Object.entries(flexibilities).sort(
      ([a], [b]) =>
        FLEXIBILITY_TYPES.indexOf(/** @type {Schema.Flexibility} */ (a)) -
        FLEXIBILITY_TYPES.indexOf(/** @type {Schema.Flexibility} */ (b))
    )
  }

  /** @param {Schema.Offer[]} [offers] */
  const cheapestOffer = (offers) =>
    offers?.length
      ? offers.reduce((cheapest, offer) => {
          return offer.price.amount < cheapest.price.amount ? offer : cheapest
        })
      : null

  /** @param {Schema.Offer[]} [offers] */
  const classOption = (offers) => {
    if (!offers) return null

    if (offers.some((offer) => offer.id === selectedOffer?.id)) {
      return selectedOffer
    }

    const matchingFlexibility = offers.filter(
      (offer) =>
        !selectedOffer ||
        highestFlexibility(offer) === highestFlexibility(selectedOffer)
    )

    return cheapestOffer(
      matchingFlexibility.length ? matchingFlexibility : offers
    )
  }

  let text = register(i18n)

  /** @type {{
   *   segments?: Schema.Segment[],
   *   offers?: Schema.Offer[],
   *   selectedOffer?: Schema.Offer,
   *   passengers?: Schema.Passenger[],
   *   onchange?: function({ offer: string, part?: { id: string, placeProperties?: { propertyId: string, optionId: string }[], addAncillaries?: Schema.AddAncillaryInput[], removeAncillaries?: Schema.RemoveAncillaryInput[] } }): void
   * }} */
  let { segments, offers, selectedOffer, passengers, onchange } = $props()

  let accommodationSubTypes = $derived({
    PRIVATE_COUCHETTE_4: text`Private couchette`,
    PRIVATE_COUCHETTE_5: text`Private couchette`,
    PRIVATE_COUCHETTE_6: text`Private couchette`,
    MINI_SUITE: text`Mini cabin`,
    SINGLE: text`Single sleeper`,
    DOUBLE: text`Double sleeper`,
    TRIPLE: text`Triple sleeper`,
    PRIVATE_DOUBLE: text`Private sleeper`,
    PRIVATE_TRIPLE: text`Private sleeper`
  })

  let days = $derived(
    segments
      ? differenceInCalendarDays(
          new Date(segments?.at(-1)?.arrivalAt),
          new Date(segments?.at(0)?.departureAt)
        )
      : null
  )

  let hasNonSeatAccommodation = $derived(
    offers?.some((offer) =>
      offer.parts.some(
        (part) => 'accommodation' in part && part.accommodation.type !== 'SEAT'
      )
    )
  )

  let firstClassOffers = $derived(offers?.filter(isFirstClass))

  let secondClassOffers = $derived(offers?.filter(isSecondClass))

  let secondClassOfferOption = $derived(classOption(secondClassOffers))

  let firstClassOfferOption = $derived(classOption(firstClassOffers))

  let cheapestSecondClassOffer = $derived(cheapestOffer(secondClassOffers))

  let cheapestFirstClassOffer = $derived(cheapestOffer(firstClassOffers))

  let flexibilityCandidates = $derived(
    selectedOffer
      ? isFirstClass(selectedOffer)
        ? firstClassOffers
        : secondClassOffers
      : []
  )

  let hasUnknownFlexibility = $derived(
    flexibilityCandidates?.some((offer) =>
      offer.parts.some((part) => part.flexibility === 'UNKNOWN')
    )
  )

  let flexibilityOffers = $derived(
    // If there is an unknown flexibility, we defer to comfort selection
    hasUnknownFlexibility
      ? []
      : cheapestOfferPerFlexibility(flexibilityCandidates)
  )

  let cheapestFlexibilityOffer = $derived(
    cheapestOffer(flexibilityOffers.map(([, offer]) => offer).filter(Boolean))
  )

  let comfortOffers = $derived(
    hasUnknownFlexibility
      ? flexibilityCandidates
      : selectedOffer
        ? offers
            ?.filter((offer) => {
              if (isFirstClass(offer) !== isFirstClass(selectedOffer)) {
                return false
              }
              if (isSecondClass(offer) !== isSecondClass(selectedOffer)) {
                return false
              }
              if (
                highestFlexibility(offer) !== highestFlexibility(selectedOffer)
              ) {
                return false
              }
              return true
            })
            .sort((a, b) => a.price.amount - b.price.amount)
        : []
  )

  let cheapestComfortOffer = $derived(cheapestOffer(comfortOffers))

  let placeProperties = $derived(
    selectedOffer?.parts
      .filter((part) => part.__typename === 'ReservationPart')
      .flatMap((/** @type {Schema.ReservationPart} */ part) =>
        part.placeProperties?.map(
          (placeProperty) =>
            /** @type {[string, Schema.PlaceProperty]} */ ([
              part.id,
              placeProperty
            ])
        )
      )
      .filter(Boolean) || []
  )

  let alternateClassParts = $derived.by(() => {
    if (!selectedOffer) return []

    const oppositeServiceClasses = isFirstClass(selectedOffer)
      ? SECOND_CLASS_SERVICE_CLASSES
      : FIRST_CLASS_SERVICE_CLASSES

    return selectedOffer.parts.filter(
      (part) =>
        'serviceClass' in part &&
        oppositeServiceClasses.includes(part.serviceClass)
    )
  })

  let ancillaries = $derived(
    selectedOffer?.parts
      .filter((part) => part.__typename === 'ReservationPart')
      .flatMap((/** @type {Schema.ReservationPart} */ part) =>
        part.ancillaries?.map(
          (ancillary) =>
            /** @type {[string, Schema.Ancillary]} */ ([part.id, ancillary])
        )
      )
      .filter(Boolean)
  )

  let conditions = $derived(
    selectedOffer?.parts.reduce((acc, part) => {
      const descriptions = unique(
        part.conditions
          .map((condition) => condition.description)
          .filter(
            (description) =>
              !/^(Exchange|Refund): See (exchange|refund).?$/i.test(description)
          )
      )

      if (descriptions.length) {
        const price = part.price ? money(part.price) : ''
        const key = [part.__typename, price, ...descriptions].join(',')
        if (acc.every((item) => item.flat().join(',') !== key)) {
          acc.push([
            /** @type {string} */ (part.__typename),
            price,
            descriptions
          ])
        }
      }

      return acc
    }, /** @type {[string, string, string[]][]} */ ([]))
  )

  const asTimestamp = (date) => {
    return new Date(date).toLocaleTimeString(State.language, {
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    })
  }

  /**
   * @param {Schema.Offer} offer
   * @returns {{ label: string, description?: string[] }}
   */
  const comfortLabel = (offer) => {
    /** @type {Set<Schema.AccommodationType>} */
    const allAccommodations = new Set(
      comfortOffers?.flatMap((offer) =>
        offer.parts
          .filter((part) => 'accommodation' in part)
          .map((part) => part.accommodation.type)
      )
    )

    const bestPart =
      /** @type {{ comfortClass: string, serviceClass: Schema.ServiceClass }} */ (
        offer.parts
          .filter((part) => 'serviceClass' in part)
          .filter((part) => part.comfortClass)
          .reduce(
            (best, part) =>
              SERVICE_CLASSES.indexOf(part.serviceClass) >=
              SERVICE_CLASSES.indexOf(best.serviceClass)
                ? part
                : best,
            /** @type {{ comfortClass?: string?, serviceClass: Schema.ServiceClass }} */ ({
              comfortClass: isFirstClass(offer)
                ? text`1st Class`
                : text`2nd Class`,
              serviceClass: 'UNKNOWN'
            })
          )
      )

    const accommodations = offer.parts
      .filter((part) => 'accommodation' in part)
      .map((part) => part.accommodation)

    const uniqueAccommodationTypes = unique(
      accommodations.map((accommodation) => accommodation.type)
    )

    const description = unique(
      offer.parts
        .filter((part) => 'accommodation' in part)
        .map((part) => part.accommodation.description)
        .filter(Boolean)
    )

    if (hasNonSeatAccommodation || allAccommodations.size > 1) {
      return {
        label:
          uniqueAccommodationTypes.length === 1 &&
          uniqueAccommodationTypes[0] !== 'UNKNOWN'
            ? accommodationSubTypes[accommodations[0]?.subType || 'UNKNOWN'] ||
              text(uniqueAccommodationTypes[0])
            : text(bestPart.comfortClass),
        description: description.map((value) => text(value))
      }
    }

    return { label: text(bestPart.comfortClass), description }
  }

  /** @param {Schema.Passenger} passenger */
  const getAge = (passenger) => {
    if (passenger.type === 'ADULT') return null
    if (passenger.age) return passenger.age
    if (!segments) return null

    const birth = new Date(passenger.birthDate)
    const departure = new Date(segments.at(0).departureAt)
    const age = departure.getFullYear() - birth.getFullYear()
    const monthDiff = departure.getMonth() - birth.getMonth()
    const dayDiff = departure.getDate() - birth.getDate()
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      return age - 1
    }
    return age
  }

  const ancillariesForPassenger = (passenger) => {
    const selections = ancillaries?.filter(([_, ancillary]) =>
      ancillary.selections.some(
        (selection) => selection.passengerId === passenger.id
      )
    )

    return selections?.length
      ? selections.map(([_, ancillary]) => ancillary.name).join(', ')
      : null
  }

  const onplacepropertyselect = (partId, placeProperty) => (event) => {
    if (selectedOffer && onchange) {
      onchange({
        offer: selectedOffer.id,
        part: {
          id: partId,
          placeProperties: [
            {
              propertyId: placeProperty.id,
              optionId: event.target.value
            }
          ]
        }
      })
    }
  }

  /** @type {function(Schema.Offer | null | undefined): function(Event): void} */
  const onofferselect = (offer) => (event) => {
    if (!offer || offer.id === selectedOffer?.id) {
      event.preventDefault()
    } else if (onchange) {
      onchange({ offer: offer.id })
      event.preventDefault()
    }
  }

  /** @type {function(string, Schema.Ancillary, Schema.Passenger): function(Event): void} */
  const onancillaryselect = (partId, ancillary, passenger) => (event) => {
    if (selectedOffer && onchange) {
      onchange({
        offer: selectedOffer.id,
        part: {
          id: partId,
          addAncillaries: [
            {
              ancillaryId: ancillary.id,
              passengerId: passenger.id
            }
          ]
        }
      })
      event.preventDefault()
    }
  }

  /** @type {function(string, Schema.AncillarySelection): function(Event): void} */
  const onancillaryremove = (partId, ancillary) => (event) => {
    if (selectedOffer && onchange) {
      onchange({
        offer: selectedOffer.id,
        part: {
          id: partId,
          removeAncillaries: [{ id: ancillary.id }]
        }
      })
      event.preventDefault()
    }
  }
</script>

{#snippet option(
  /** @type {{
  label: string,
  description?: string[],
  onclick?: function(Event): void,
  name?: string,
  value?: string,
  price?: Schema.Money?,
  selected?: boolean,
  disabled?: boolean,
  checkbox?: boolean
}} */ {
    label,
    description = [],
    onclick,
    name,
    value,
    price = null,
    selected = false,
    disabled = false,
    checkbox = false
  }
)}
  <button
    {name}
    {value}
    {disabled}
    class:selected
    class:checkbox
    class:branded={config.primaryColor}
    class="option"
    type="submit"
    formnovalidate
    {onclick}>
    {#if selected}
      <span class="symbol checkmark">
        <Symbol name="checkmark" circle={!checkbox} size="fill" />
      </span>
    {/if}
    <span class="content">
      <span class="title">
        {label}
        {#if price}
          <span class="price">
            +{money(price)}
          </span>
        {/if}
      </span>
      {#each description as value}
        <span class="description">
          {@html value}
        </span>
      {/each}
    </span>
  </button>
{/snippet}

<div class="offer-selection theme-reset">
  <div class="layout">
    <div class="body">
      <div class="header">
        <div class="label">
          {text`Journey details`}
        </div>
        <div class="times">
          {#if segments}
            {asTimestamp(segments.at(0).departureAt)}
            <Symbol name="arrow" prefix suffix />
            {asTimestamp(segments.at(-1).arrivalAt)}
          {:else}
            <Loader length={6} />
          {/if}
          {#if days}
            <sup class="days">+{days}</sup>
          {/if}
        </div>
        <div class="date">
          {#if segments}
            {new Date(segments.at(0).departureAt).toLocaleDateString(
              State.language,
              {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              }
            )}
          {:else}
            <Loader length={5} />
          {/if}
        </div>
        <ol class="trains">
          {#if segments}
            {#each segments as segment}
              <li class="train">
                <div class="trainrow">
                  {#if segment.operator.image}
                    <img
                      class="logo"
                      src={segment.operator.image.url}
                      alt={segment.operator.name}
                      title={segment.operator.name} />
                  {/if}
                  {segment.identifier?.replace(/^(\d)/, '#$1')}
                  <span>{segment.operator.name}</span>
                </div>
                <div class="trainrow">
                  {#if segment.serviceBrand}
                    {#if segment.serviceBrand.image}
                      <img
                        class="logo"
                        src={segment.serviceBrand.image.url}
                        alt={segment.serviceBrand.name}
                        title={segment.serviceBrand.name} />
                    {/if}
                    {segment.serviceBrand.name}
                  {/if}
                </div>
              </li>
            {/each}
          {:else}
            <li class="train">
              <div class="trainrow">
                <Loader length={5} />
              </div>
              <div class="trainrow">
                <Loader length={3} />
              </div>
            </li>
          {/if}
        </ol>
      </div>
      <ol class="route">
        {#if segments}
          {#each segments as segment, index}
            <li
              class="location"
              class:transfer={index > 0}
              class:origin={index === 0}>
              <span class="u-textTruncate">{segment.origin.name}</span>
            </li>
          {/each}
          <li class="location destination">
            <span class="u-textTruncate">
              <strong>{segments[segments.length - 1].destination.name}</strong>
            </span>
          </li>
        {:else}
          <li class="location origin">
            <Loader length={3} />
          </li>
          <li class="location destination">
            <Loader length={3} />
          </li>
        {/if}
      </ol>
    </div>
    <div class="body secondary">
      {#if secondClassOfferOption || firstClassOfferOption}
        <div class="group">
          <span class="label">
            {text`Select class`}
          </span>
          <div class="options">
            {@render option({
              label: text`2nd Class`,
              name: 'offer',
              value: secondClassOfferOption?.id,
              onclick: onofferselect(secondClassOfferOption),
              selected:
                selectedOffer &&
                selectedOffer.id === secondClassOfferOption?.id,
              disabled: !secondClassOfferOption,
              price: cheapestSecondClassOffer
                ? {
                    amount: 0,
                    currency: cheapestSecondClassOffer.price.currency
                  }
                : null
            })}
            {@render option({
              label: text`1st Class`,
              name: 'offer',
              value: firstClassOfferOption?.id,
              onclick: onofferselect(firstClassOfferOption),
              price:
                cheapestFirstClassOffer && cheapestSecondClassOffer
                  ? {
                      amount:
                        cheapestFirstClassOffer.price.amount -
                        cheapestSecondClassOffer.price.amount,
                      currency: cheapestFirstClassOffer.price.currency
                    }
                  : null,
              selected:
                selectedOffer && selectedOffer.id === firstClassOfferOption?.id,
              disabled: !firstClassOfferOption
            })}
          </div>
        </div>
      {/if}
      {#if flexibilityOffers.some(([, offer]) => offer)}
        <div class="group">
          <span class="label">
            {text`Select flexibility`}
          </span>
          <div class="options">
            {#each flexibilityOffers as [flexibility, offer] (offer?.id || flexibility)}
              {#if offer}
                {@render option({
                  label:
                    flexibility === 'UNKNOWN'
                      ? offer.parts
                          .map((part) => part.comfortClass)
                          .filter(Boolean)[0] || text`Ticket`
                      : text(flexibility),
                  name: 'offer',
                  value: offer.id,
                  onclick: onofferselect(offer),
                  selected:
                    selectedOffer &&
                    highestFlexibility(selectedOffer) ===
                      highestFlexibility(offer),
                  price: cheapestFlexibilityOffer
                    ? {
                        amount:
                          offer.price.amount -
                          cheapestFlexibilityOffer.price.amount,
                        currency: offer.price.currency
                      }
                    : null
                })}
              {:else}
                {@render option({ label: text(flexibility), disabled: true })}
              {/if}
            {:else}
              {@render option({ label: text`NON_FLEX`, disabled: true })}
              {@render option({ label: text`SEMI_FLEX`, disabled: true })}
              {@render option({ label: text`FULL_FLEX`, disabled: true })}
            {/each}
          </div>
        </div>
      {/if}
      {#if comfortOffers && comfortOffers.length > 0}
        <div class="group">
          <span class="label">
            {comfortOffers.length === 1 ? text`Comfort` : text`Select comfort`}
          </span>
          <div class="options">
            {#each comfortOffers as offer (offer.id)}
              {@const { label, description } = comfortLabel(offer)}
              {@render option({
                label: label,
                description: description,
                name: 'offer',
                value: offer.id,
                onclick: onofferselect(offer),
                disabled: comfortOffers.length === 1,
                selected: selectedOffer?.id === offer.id,
                price:
                  comfortOffers.length === 1 || !cheapestComfortOffer
                    ? null
                    : {
                        amount:
                          offer.price.amount -
                          cheapestComfortOffer.price.amount,
                        currency: offer.price.currency
                      }
              })}
            {/each}
          </div>
        </div>
      {/if}
      {#each placeProperties as [partId, placeProperty]}
        <div class="group">
          <label class="label" for={placeProperty.id}>
            {text(placeProperty.type)}
            {#if placeProperty.required}
              <span class="required">*</span>
            {/if}
          </label>
          <Select
            onchange={onplacepropertyselect(partId, placeProperty)}
            id={placeProperty.id}
            name={placeProperty.id}
            required={placeProperty.required}
            value={placeProperty.selectedOption?.id}
            placeholder={text(`Select ${placeProperty.type}`)}
            options={placeProperty.availableOptions.map((option) => ({
              label: text(option.value),
              value: option.id
            }))} />
          <input
            type="hidden"
            name="placeProperty"
            value="{partId}.{placeProperty.id}" />
        </div>
      {/each}
      {#if alternateClassParts.length && selectedOffer}
        <div class="group">
          <span class="label">{text`Mixed comfort class`}</span>
          <div class="small">
            <Html>
              <p>
                {text`Some parts of the journey are not in ${isFirstClass(selectedOffer) ? text`1st Class` : text`2nd Class`}.`}
              </p>
              <ul>
                {#each alternateClassParts as part}
                  <li>
                    {part.segments
                      .map((segment) => segment.origin.name)
                      .join(' - ')} - {part.segments[part.segments.length - 1]
                      .destination.name}
                    )}
                  </li>
                {/each}
              </ul>
            </Html>
          </div>
        </div>
      {/if}
      {#if ancillaries?.length && passengers?.length}
        <div class="group">
          <span class="label">{text`Add-ons`}</span>
          <Accordion items={passengers}>
            {#snippet summary(passenger, { open })}
              {@const selections = ancillariesForPassenger(passenger)}
              {#if passengers.length > 1}
                {@const age = getAge(passenger)}
                <span class="passenger">
                  <strong>
                    {text(passenger.type)}
                    {#if age}({text`${age} years`}){/if}
                  </strong>
                  <span class="selection">
                    {#if selections}
                      {selections}
                    {:else}
                      {text`No selected add-ons`}
                    {/if}
                  </span>
                </span>
              {:else}
                <span class="passenger">
                  <strong>
                    {open ? text`Hide add-ons` : text`Show add-ons`}
                  </strong>
                  <span class="selection">
                    {#if selections}
                      {selections}
                    {:else}
                      {text`No selected add-ons`}
                    {/if}
                  </span>
                </span>
              {/if}
            {/snippet}
            {#snippet content(passenger)}
              <div class="ancillaries">
                <div class="options">
                  {#each ancillaries as [partId, ancillary] (ancillary.id)}
                    {@const selected = ancillary.selections.find(
                      (selection) => selection.passengerId === passenger.id
                    )}
                    {@render option({
                      label: ancillary.name,
                      description: ancillary.description
                        ? [ancillary.description]
                        : undefined,
                      name: selected ? 'remove-ancillary' : 'add-ancillary',
                      value: `${partId}.${selected ? selected.id : ancillary.id}.${passenger.id}`,
                      onclick: selected
                        ? onancillaryremove(partId, selected)
                        : onancillaryselect(partId, ancillary, passenger),
                      selected: Boolean(selected),
                      price: ancillary.price,
                      checkbox: true
                    })}
                  {/each}
                </div>
              </div>
            {/snippet}
          </Accordion>
        </div>
      {/if}
      {#if conditions?.length}
        <div class="group">
          <span class="label">{text`Conditions`}</span>
          <div class="small">
            <Html>
              {#each conditions as [type, price, descriptions]}
                <p>
                  <strong class:u-hidden={conditions.length === 1}>
                    {text(type)}{#if price}&nbsp;({price}){/if}:
                  </strong>
                  {#each descriptions as description, index}
                    {#if index > 0}<br />{/if}
                    {@html description}
                  {/each}
                </p>
              {/each}
            </Html>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<style>
  .offer-selection {
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    font-size: 1rem;
    color: rgb(var(--rgb-text));
    background: var(--background);
    border-radius: var(--border-radius-lg);
    box-shadow: var(--box-shadow-sm);
    transition: box-shadow 200ms var(--ease-out);
  }

  .offer-selection:hover {
    box-shadow: var(--box-shadow-sm-hover);
  }

  .offer-selection:active {
    box-shadow: var(--box-shadow-sm-active);
  }

  .layout {
    display: flex;
    flex-direction: column;
  }

  @container (width >= 50rem) {
    .layout {
      flex-direction: row;
    }
  }

  .label {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    font-size: 0.8125rem;
    color: rgb(var(--rgb-muted));
    text-transform: uppercase;
  }

  /**
 * Body
 */

  .body {
    flex: 0 1 50%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.25rem;
    border-right: 1px solid rgba(var(--rgb-muted), 0.2);
  }

  @container (width >= 50rem) {
    .body {
      padding: 1.75rem 1.25rem;
      max-width: 18rem;
    }

    .secondary {
      max-width: none;
      flex-grow: 1;
    }
  }

  @container (width >= 75rem) {
    .body {
      padding: 1.75rem 1.85rem;
    }
  }

  /**
 * Header
 */

  .times {
    display: flex;
    align-items: center;
    font-size: 1.75rem;
    font-weight: bold;
    letter-spacing: -0.02rem;
  }

  .days {
    display: inline-block;
    margin: 0.4em 0 0 0.25em;
    font-size: 1rem;
  }

  .date {
    font-size: 1rem;
    margin-bottom: 1.25rem;
  }

  .train {
    width: 100%;
    padding: 0.3rem 0;
    border: solid rgba(var(--rgb-gray), 0.25);
    border-width: 1px 0 0;
    font-weight: normal;
    font-size: 0.875rem;
    color: rgb(var(--rgb-muted));
  }

  .train:last-child {
    border-bottom-width: 1px;
  }

  .trainrow {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.125rem 0;
    font-weight: 600;
  }

  .trainrow + .trainrow {
    font-weight: normal;
  }

  .logo {
    display: block;
    width: auto;
    height: 1rem;
  }

  /**
 * Route
 */

  .route {
    width: 100%;
    padding-left: 2.5rem;
    margin: -0.375rem 0 0;
    position: relative;
  }

  @container (width >= 50rem) {
    .route {
      margin: -0.375rem 1.5rem -0.375rem 0;
    }
  }

  .route::before {
    content: '';
    width: 1.5rem;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgb(var(--rgb-primary, var(--rgb-highlight)));
    border-radius: 0.75rem;
  }

  .location {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 0.375rem 0;
    font-size: 1rem;
    white-space: nowrap;
  }

  .location::before {
    content: '';
    width: 0.25rem;
    height: 0.25rem;
    position: absolute;
    left: 0.65rem;
    transform: translateY(0.5rem);
    background: var(--background);
    border-radius: 100%;
    transition: transform 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .origin,
  .destination {
    font-size: 1rem;
  }

  .origin::before,
  .destination::before {
    width: 0.5rem;
    height: 0.5rem;
    left: 0.5rem;
    transform: translateY(0.5rem);
  }

  /**
  * Options
  */

  .options {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
    gap: 0.75rem;
  }

  .option {
    display: flex;
    gap: 0.5rem;
    padding: 0.75rem;
    position: relative;
    z-index: 0;
    text-align: left;
    font-size: 1rem;
    user-select: none;
    font-weight: 500;
    border: 2px solid rgba(var(--rgb-gray), 0.25);
    border-radius: var(--border-radius-md);
  }

  .option.selected {
    border-color: rgb(var(--rgb-primary, var(--rgb-green)));
    background-color: rgba(var(--rgb-green), 0.05);
  }

  .option.selected:not(.checkbox) {
    cursor: default;
  }

  .option:disabled {
    border-color: transparent;
    cursor: default;
    background-color: rgba(var(--rgb-gray), 0.05);
  }

  .option:disabled:not(.selected) {
    color: rgb(var(--rgb-muted));
  }

  .option:not(:is(:disabled, .selected)) {
    box-shadow: var(--box-shadow-sm);
    transition: var(--box-shadow-transition), var(--background-transition);
  }

  .option:hover:not(:is(:disabled, .selected)) {
    box-shadow: var(--box-shadow-sm-hover);
  }

  .option.branded.selected:not(:disabled) {
    background-color: transparent;
  }

  .symbol {
    flex: 0 0 auto;
    width: 1.25rem;
    height: 1.25rem;
  }

  .checkmark {
    --current-background: rgb(var(--rgb-primary, var(--rgb-green)));
    --current-color: rgb(var(--rgb-white));
  }

  .option.checkbox .symbol {
    padding: 0.175rem;
    border-color: rgb(var(--rgb-primary, var(--rgb-green)));
    background-color: rgb(var(--rgb-primary, var(--rgb-green)));
    border-radius: var(--border-radius-xs);
  }

  .content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .title {
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
  }

  .description {
    color: rgb(var(--rgb-muted));
    font-size: 0.875rem;
    font-weight: normal;
  }

  .option:not(.selected)::before {
    content: '';
    display: block;
    flex: 0 0 auto;
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid rgba(var(--rgb-gray), 0.25);
    border-radius: 100%;
  }

  .option.checkbox::before {
    border-radius: var(--border-radius-xs);
  }

  .price {
    margin-left: auto;
    font-size: 0.875rem;
    font-weight: normal;
    white-space: nowrap;
  }

  .small {
    --current-font-size: 0.875rem;
  }

  .ancillaries {
    margin-top: 0.5rem;
  }

  .passenger {
    display: flex;
    flex-direction: column;
  }

  .selection {
    color: rgb(var(--rgb-muted));
    font-size: 0.875rem;
  }
</style>
